import React from "react";
import { Tooltip } from "react-tooltip";
import { handleTooltip } from "../../utils/handleToolTip";

const InfoTooltip = ({ style, title, tooltipId }) => (
  <>
    <span
      className="glyphicon glyphicon-info-sign"
      style={style}
      data-tooltip-id={tooltipId}
      data-tooltip-content={handleTooltip(title)}
    />
    <Tooltip id={tooltipId} place="bottom" className="custom-tooltip" />
  </>
);

export default InfoTooltip;
